"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regexVersion = exports.legal = exports.fax = exports.phone = exports.email = exports.copyright = exports.year = exports.companyName = void 0;
exports.companyName = 'smapiot GmbH';
exports.year = new Date().getFullYear().toString();
exports.copyright = `© ${exports.year} ${exports.companyName}. All rights reserved.`;
exports.email = 'info@smapiot.com';
exports.phone = '+49 (0) 8102 9998476';
exports.fax = '+49 (0) 8102 9984395';
exports.legal = [
    {
        name: 'Imprint',
        link: '/imprint',
    },
    {
        name: 'Privacy Policy',
        link: '/privacy',
    },
    {
        name: 'Terms and Conditions',
        link: '/terms',
    },
];
exports.regexVersion = /^\d+(\.\d+)?$/;
